import { render, staticRenderFns } from "./mypage-dashboard-menu.vue?vue&type=template&id=3033bf02&"
import script from "./mypage-dashboard-menu.vue?vue&type=script&lang=js&"
export * from "./mypage-dashboard-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports